import { render, staticRenderFns } from "./answersuccess.vue?vue&type=template&id=6f604b60&scoped=true&"
import script from "./answersuccess.vue?vue&type=script&lang=js&"
export * from "./answersuccess.vue?vue&type=script&lang=js&"
import style0 from "./answersuccess.vue?vue&type=style&index=0&id=6f604b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f604b60",
  null
  
)

export default component.exports